// extracted by mini-css-extract-plugin
export default {"search_container":"search_search_container__FwAkN","search_block":"search_search_block__HWd8w"};